module.exports = __webpack_public_path__ + "img/pauli-y-root-14.1e49e781.svg";